import styled from '@emotion/styled'

import theme from 'styles/theme'

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background: ${theme.token.var('colors.green.a50')};
  border-radius: ${theme.token.var('borderRadius.extraSmall')};
`

export const Icon = styled.img<{ isExpanded: boolean }>`
  transform: ${({ isExpanded }) => (isExpanded ? 'rotate(180deg)' : 'rotate(0)')};
  transition: transform 0.3s ease;
`
